import { apiFetch } from "core/api/base";

export function * postPlaygroundGroupCreate ({ namespace, model }) {
	return yield apiFetch({
		endpoint: `/v1/playground/group/${namespace}`,
		method: "POST",
		authenticated: true,
		body: JSON.stringify(model)
	});
}
